import {Box, Button, Text,} from "@chakra-ui/react";
import {AddIcon} from "@chakra-ui/icons";
import React from "react";

interface UserHeaderProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function UserHeader({setOpen}: UserHeaderProps) {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            height="64px"
            width="100%"
            px={4}
        >
            {/* Left label */}
            <Text fontSize="2xl" fontWeight="bold" color="black">
                Doctors List
            </Text>

            {/* Right side buttons */}
            <Box display="flex" alignItems="center" gap={4}>
                <Button
                    leftIcon={<AddIcon/>}
                    bg="#422AFB"
                    color="white"
                    _hover={{bg: "#5842ff"}}
                    textTransform="none"
                    fontWeight="bold"
                    height="40px"
                    onClick={() => setOpen(true)}
                >
                    New User
                </Button>
            </Box>
        </Box>
    );
}

export default UserHeader;
